import IBaseComponent from '@components/FormFlow/Interfaces/Base/IBaseComponent';
import TaskIconDictionary from '@components/FormFlow/Util/TaskIconDictionary';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faClone, faCog, faGripVertical, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import { Theme } from '@src/styled-components';
import { Modal } from 'antd';
import React from 'react';
import styled from 'styled-components';

import SampleComponentProcess from './components/SampleComponentProcess';
import SampleImageComponentProcess from './components/SampleImageComponentProcess';
import SampleVideoComponentProcess from './components/SampleVideoComponentProcess';
import SelectComponentProcess from './components/SelectComponentProcess';
import ToDoComponentProcess from './components/TODOComponentProcess';
import TreeViewComponentProcess from './components/TreeViewComponentProcess';

const confirm = Modal.confirm;

export interface IProcessComponentProps {
  onClickRemoveButton: Function;
  onDuplicateComponent: Function;
  onEditComponent: Function;
  onTitleComponentChange: Function;
  titleComponentValue: string;
  onDescriptionComponentChange: Function;
  descriptionComponentValue: string;
  idComponent: string;
  typeComponent: ComponentType
  enableDescription: boolean;
  isActive: boolean;
  currentComponent: any;
  url?: string;
  options?: string;
  minMultiple?: number;
  maxMultiple?: number;
  onChangeComponentValue: Function;
  ConfigComponent?: boolean;
  isRepeat?: boolean;
  isRequired?: boolean;
  drag?: any;
  handleUpdateSortableListKey?: Function;
}


interface IProcessComponentState {
}

export default class ProcessComponent extends React.Component<IProcessComponentProps, IProcessComponentState> {

  constructor(props: IProcessComponentProps) {
    super(props);
    this.state = {
    }
  }

  showDeleteConfirm(onDelete: Function) {
    confirm({
      title: I18n.l("formflow.labels.titleRemoveComponent"),
      content: I18n.l("formflow.labels.removeComponent"),
      okText: I18n.l("common.delete"),
      okType: 'primary',
      cancelText: I18n.l("common.cancel"),
      onOk() {
        onDelete()
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  renderContentComponents(component: IBaseComponent | null) {
    if (component !== null) {
      switch (this.props.typeComponent) {
        case ComponentType.SAMPLEIMAGE: {
          return (<SampleImageComponentProcess key={this.props.idComponent} url={this.props.url} onChange={this.props.onChangeComponentValue()} />)
        }
        case ComponentType.SAMPLEVIDEO: {
          return (<SampleVideoComponentProcess key={this.props.idComponent} url={this.props.url} onChange={this.props.onChangeComponentValue()} handleUpdateSortableListKey={this.props.handleUpdateSortableListKey} />)
        }
        case ComponentType.SELECT: {
          return (<SelectComponentProcess key={this.props.idComponent} options={this.props.options} onChange={this.props.onChangeComponentValue()} minMultiple={this.props.currentComponent.minMultiple} maxMultiple={this.props.currentComponent.maxMultiple}/>)
        }
        case ComponentType.GOTO: {
          return (<ToDoComponentProcess key={this.props.idComponent} repeat={this.props.isRepeat} options={this.props.options} onChange={this.props.onChangeComponentValue()} />)
        }
        case ComponentType.TREEVIEW: {
          return (<TreeViewComponentProcess key={this.props.idComponent} />)
        }
        case ComponentType.SAMPLE: {
          return (<SampleComponentProcess key={this.props.idComponent} options={this.props.options} onChange={this.props.onChangeComponentValue()} />)
        }
        default: return;
      }
    }
    else return;

  }

  render() {
    const {
      onTitleComponentChange,
      titleComponentValue,
      onDuplicateComponent,
      onClickRemoveButton,
      typeComponent,
      descriptionComponentValue,
      onDescriptionComponentChange,
      onEditComponent,
      isActive,
      currentComponent,
      idComponent,
      ConfigComponent
    } = this.props;
    return (
      <>
        <CardComponent
          style={isActive && titleComponentValue === '' ? { backgroundColor: '#FFD9D9' } : isActive ? { backgroundColor: '#E0F4F8' } : {}}
          defaultChecked={titleComponentValue === '' ? true : false}
        >

          <div className="component-container">
            <div className="component-icons-left">
              {this.props.drag}
              <Icon className='item-icon-container' icon={TaskIconDictionary.get(typeComponent) as IconProp} />
            </div>
            <div className="component-content">
              <input
                value={titleComponentValue}
                style={{ width: '100%' }}
                onChange={onTitleComponentChange()}
                placeholder={I18n.l("label.titleComponent")}
                className={isActive ? 'input-style' : ''}
                key={`input${idComponent}`}
              />
              {this.props.isRequired &&
                <span className='required-box' >{I18n.l("process.isRequired")}</span>
              }
              {titleComponentValue === '' || (titleComponentValue && titleComponentValue.length < 3) &&
                <div className='input-validation'>{I18n.l("process.component.titleValidation")}</div>
              }
              {this.props.typeComponent !== ComponentType.SAMPLETEXT &&
                <>
                  <textarea
                    rows={3}
                    placeholder={I18n.l("label.descriptionComponent")}
                    value={descriptionComponentValue}
                    onChange={onDescriptionComponentChange()}
                    className={isActive ? 'text-area-style' : ''}
                  />
                </>
              }
              {this.renderContentComponents(currentComponent)}
            </div>
            <div className="component-menu-bottom">
              <span style={{ float: 'right', marginTop: '6.4rem', cursor: 'pointer' }}>
                {ConfigComponent && <span onPointerDown={() => onEditComponent()}>
                  <Icon style={{ marginRight: '1rem', fontSize: '18px' }} icon={faCog} />
                </span>}
                <span onPointerDown={() => this.showDeleteConfirm(onClickRemoveButton())}>
                  <Icon style={{ marginRight: '1rem', fontSize: '18px' }} icon={faTrash} />
                </span>
                <span onPointerDown={() => onDuplicateComponent()} >
                  <Icon style={{ fontSize: '18px' }} icon={faClone} />
                </span>
              </span>
            </div>
          </div>
        </CardComponent>
      </>
    );
  }
}

//#region CSS
const CardComponent = styled.div`
cursor: all-scroll;
padding: 25px 25px 18px 25px;
height:auto;
border-bottom: 1px solid  ${Theme.secondary.lightGrey};;
background-color: ${props => props.defaultChecked === true ? "#FFE8E8" : " #F6FCFD"};

.required-box {
  background: #7CA2BE;
  border-radius: 10px;  
  padding: 2px 7px 2px 7px;
  font-weight: bold;
  font-size: 10px;
  color: #FFFFFF;text-align: center;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.input-style {
  padding: 10px 10px 10px 10px;
  border: 1px solid ${props => props.defaultChecked === true ? "#FFD9D9" : " #E0F4F8"};
  margin-bottom: 0.5rem;
  background-color:${props => props.defaultChecked === true ? "#FFD9D9" : " #E0F4F8"};
  color: #595959;
  font-size: 14px;
}
.input-validation{
  color: red;
  margin-left: 12px;
}
.text-area-style {
  padding: 10px 10px 10px 10px;
    width: 100%;
    border: 1px solid ${props => props.defaultChecked === true ? "#FFD9D9" : " #E0F4F8"};
    background-color:${props => props.defaultChecked === true ? "#FFD9D9" : " #E0F4F8"};
}
.ant-input-number-input{
  background-color: #fff;
}
&:hover  {
  background-color:${props => props.defaultChecked === true ? "#FFD9D9" : " #E0F4F8"};
  input {
    padding: 10px 10px 10px 10px;
    border: 1px solid ${props => props.defaultChecked === true ? "#FFD9D9" : " #E0F4F8"};
    margin-bottom: 0.5rem;
    background-color: ${props => props.defaultChecked === true ? "#FFD9D9" : " #E0F4F8"};
  }
  textarea {
    padding: 10px 10px 10px 10px;
    width: 100%;
    border: 1px solid ${props => props.defaultChecked === true ? "#FFD9D9" : " #E0F4F8"};
    background-color: ${props => props.defaultChecked === true ? "#FFD9D9" : " #E0F4F8"};
  }
  .ant-input-number-input{
    background-color: #fff;
  }
}
.bg-style {
  background-color: red;
}

input {
  padding: 10px 10px 10px 10px;
  width: 100%;
  border: 1px solid ${props => props.defaultChecked === true ? "#FFE8E8" : " #F6FCFD"};
  margin-bottom: 0.5rem;
  background-color: ${props => props.defaultChecked === true ? "#FFE8E8" : " #F6FCFD"};
}
textarea {
  padding: 10px 10px 10px 10px;
  width: 100%;
  border: 1px solid ${props => props.defaultChecked === true ? "#FFE8E8" : " #F6FCFD"};
  background-color: ${props => props.defaultChecked === true ? "#FFE8E8" : " #F6FCFD"};

  ::-webkit-scrollbar {
    width: 10px;
  }
  
  ::-webkit-scrollbar-track {
    background: #f1f1f1; 
  }
   
  ::-webkit-scrollbar-thumb {
    background: #888; 
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }
}
input:focus {
  outline: none;
}

.item-icon-container{
  background-color: #DEDEDE;
  border-radius: 5px;
  color: #7E7E7E;
  font-size: 16px;
  height: 25px;
  margin-left: 5px;
  padding: 3px;
  text-align: center;
  vertical-align: -6px;
  width: 30px;
}

.component-container {
  position: relative;

  .component-icons-left {
    position: absolute;
    left: 14px;
    top: 7px;

    .drag-icon {
        margin-right: 8px;
        color: #84A1AA;
        font-size: 18px;
    }
  }
  .component-content {
    padding-left: 80px;
    padding-bottom: 50px;
  }

  .component-menu-bottom {
      position: absolute;
      bottom: 5px;
      right: 0;
      color: #84A1AA;
  }
}
`